import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

// Reducers
import AdminReducer from 'reducers/admin_reducer';
import ArchiveReducer from './archive-reducer';
import CompanyReducer from './company-reducer';
import ContactsReducer from './contacts-reducer';
import SettingsReducer from './settings-reducer';
import UsersReducer from './users-reducer';
import LoggingsReducer from './loggings-reducer';
import AssetReducer from 'reducers/assets-reducer';
import StockPartsReducer from 'reducers/stock-parts-reducer';
import workOrdersReducer from 'reducers/work-orders-reducer';
import servicesReducer from 'reducers/services-reducer';
import serviceItemsReducer from 'reducers/service-items-reducer';
import EmployeesReducer from 'reducers/employees-reducer-port';
import ChatReducer from 'reducers/chat-reducer';
import ProfilesReducer from './profiles-reducer'

// Combine Reducers
var reducers = combineReducers({
	admin: AdminReducer,
	archive: ArchiveReducer,
	assets: AssetReducer,
	chat: ChatReducer,
	company: CompanyReducer,
	contacts: ContactsReducer,
	employees: EmployeesReducer,
	loggings: LoggingsReducer,
	settings: SettingsReducer,
	stockParts: StockPartsReducer,
	services: servicesReducer,
	serviceItems: serviceItemsReducer,
	toastr: toastrReducer,
	users: UsersReducer,
	workOrders: workOrdersReducer,
	profiles: ProfilesReducer,
});

export default reducers;